import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router';
import { appEnvironment } from '@/configurations/app-configs/app.setting.config';
import Portfolio from '../../components/MyAccount/Portfolio/Portfolio';
import TransactionHistory from '@/components/MyAccount/TransactionHistory/TransactionHistory';
import '../../assets/styles/pages/my-account/my-account.scss';
import { ctrlID } from '@/constants/ctr-id';
import BlockControl from '@/components/BlockControl/BlockControl'
import AccountBalanceAction from '../../components/MyAccount/AccountBalanceAction'
class MyAccount extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let { p_Identifier } = this.props;
    let enableOneRowAccountBalance = p_Identifier ? p_Identifier.child.includes(ctrlID.oneRowAccountBalanceCtrl) : true;
    return (
      <div className="my-account-container">
        <BlockControl name='account-balance'>
          <section className="secion-top">
              <AccountBalanceAction enableOneRowAccountBalance = {enableOneRowAccountBalance}/>
          </section>
        </BlockControl>
        <BlockControl name='account-portfolio'>
        <section className="section-center">
          <Portfolio isFilter autoSizeColumns={false} />
        </section>
        </BlockControl>
        <BlockControl name='transaction-history'>
        <section className="section-bottom">
          <TransactionHistory />
        </section>
        </BlockControl>
      </div>
    )
  }
}

class RouteWithSubRoutes extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <Route
        path={this.props.route.path}
        render={props => (
          // pass the sub-routes down to keep nesting
          <Component {...props} routes={route.routes} />
        )}
      />
    );
  }
}

MyAccount.defaultProps = {
  p_Identifier: appEnvironment.custom_ctr_configs.accountCtrl
}

export default withRouter(connect(
  state => ({ mode: state.app.mode })
)(MyAccount))